import { useMemo } from 'react';
import { motifSvg, type MotifOptions } from './motif';

/** The wordmark (D-73): "neural" in ink, "repo" in Ember, Plex Sans 600, −0.035em. */
export function Wordmark({ size = 18, href }: { size?: number; href?: string }) {
  const inner = (
    <>
      <span>neural</span>
      <span className="nr-wordmark-repo">repo</span>
    </>
  );
  const style = { fontSize: size };
  return href ? (
    <a className="nr-wordmark" href={href} style={style} aria-label="NeuralRepo">{inner}</a>
  ) : (
    <span className="nr-wordmark" style={style} aria-label="NeuralRepo">{inner}</span>
  );
}

/**
 * The D-77 motif, sized to its box. Decorative; only for signature spots
 * (landing hero, empty states, error pages, the empty mind map — D-70, D-79).
 * The SVG comes from our own generator, so injecting it is safe.
 */
export function Motif({ className, ...opts }: MotifOptions & { className?: string }) {
  const svg = useMemo(
    () => motifSvg(opts),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [opts.width, opts.height, opts.theme, opts.seed, opts.pitch, opts.fx, opts.fy, opts.lit, opts.dim, opts.mask, opts.id],
  );
  return <div className={`nr-motif${className ? ` ${className}` : ''}`} aria-hidden="true" dangerouslySetInnerHTML={{ __html: svg }} />;
}

/** Current resolved theme: <html data-theme> (set by useTheme), else the saved choice, else the system. */
export function currentTheme(): 'dark' | 'light' {
  const attr = document.documentElement.getAttribute('data-theme');
  if (attr === 'light' || attr === 'dark') return attr;
  let saved: string | null = null;
  try { saved = localStorage.getItem('nrepo:theme'); } catch { /* private mode */ }
  if (saved === 'light' || saved === 'dark') return saved;
  if (saved === 'system') return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  return 'dark';
}
